import { IntegrationMetadata } from '../../../lib/interface';
import { snakeCaseToTitleCase } from '../../../utils/string';

export function formatIntegrationMetadataForDisplay(
  integration_metadata: IntegrationMetadata | undefined,
): Record<string, string | undefined> {
  if (!integration_metadata) return {};

  const {
    integration_id,
    adyen_metadata,
    gocardless_metadata,
    stripe_metadata,
    cybersource_metadata,
    cashfree_metadata,
  } = integration_metadata;

  let rows: Record<string, string | undefined> = {};
  let knownKeys: string[] = [];
  let providerMeta: Record<string, unknown> | undefined;

  if (integration_id === 'ADYEN' && adyen_metadata) {
    rows = {
      'Auth Code': adyen_metadata.auth_code,
      'Payment Method ID': adyen_metadata.payment_method_id,
      'PSP Reference': adyen_metadata.psp_reference,
      'Recurring Processing Model': adyen_metadata.recurring_processing_model,
    };
    knownKeys = ['auth_code', 'payment_method_id', 'psp_reference', 'recurring_processing_model'];
    providerMeta = adyen_metadata;
  } else if (integration_id === 'GOCARDLESS' && gocardless_metadata) {
    rows = {
      'Funds Settlement': gocardless_metadata.funds_settlement,
      'Last Event/Action': gocardless_metadata.last_action,
      'Mandate ID': gocardless_metadata.mandate_id,
      'Next Possible Charge Date': gocardless_metadata.next_possible_charge_date,
      Reference: gocardless_metadata.reference,
      Scheme: gocardless_metadata.scheme,
      Status: gocardless_metadata.status,
    };
    knownKeys = [
      'funds_settlement',
      'last_action',
      'mandate_id',
      'next_possible_charge_date',
      'reference',
      'scheme',
      'status',
    ];
    providerMeta = gocardless_metadata;
  } else if (integration_id === 'STRIPE' && stripe_metadata) {
    rows = {
      'Customer ID': stripe_metadata.customer?.id,
      'Payment Method ID': stripe_metadata.payment_method?.id,
    };
    knownKeys = ['customer', 'payment_method'];
    providerMeta = stripe_metadata;
  } else if (integration_id === 'CYBERSOURCE' && cybersource_metadata) {
    rows = { 'Payment Token': cybersource_metadata.payment_token };
    knownKeys = ['payment_token'];
    providerMeta = cybersource_metadata;
  } else if (integration_id === 'CASHFREE' && cashfree_metadata) {
    rows = { 'Subscription ID': cashfree_metadata.cf_subscription_id };
    knownKeys = ['cf_subscription_id'];
    providerMeta = cashfree_metadata;
  }

  if (providerMeta) {
    for (const [key, value] of Object.entries(providerMeta)) {
      if (knownKeys.includes(key) || typeof value !== 'string') continue;
      const label = snakeCaseToTitleCase(key);
      if (rows[label] === undefined) rows[label] = value;
    }
  }

  return rows;
}
